import { TypeSpec } from 'src/models/Sidekick/SidekickModuleSpec';

export interface ParsedSpec {
  children?: ParsedSpec[];
  isArray: boolean;
  name: string;
  nullable?: boolean;
  type: string;
}

export const parseSpecRecursive = (spec: TypeSpec, name: string = ''): ParsedSpec[] => {
  const result: ParsedSpec[] = [];

  const parse = (spec: TypeSpec, name: string): ParsedSpec => {
    const parsed: ParsedSpec = { name, type: spec.type, nullable: spec.null, isArray: spec.type === 'array' };

    if (spec.type === 'object' && spec.props) {
      parsed.children = Object.entries(spec.props).flatMap(([key, value]) => parseSpecRecursive(value, key));
    } else if (spec.type === 'array' && spec.items) {
      if (spec.items.type === 'object' && spec.items.props) {
        parsed.children = Object.entries(spec.items.props).flatMap(([key, value]) => parseSpecRecursive(value, key));
      }
    }

    return parsed;
  };
  result.push(parse(spec, name));
  return result;
};
